'use client';

import { c as _c } from "react/compiler-runtime";
import type { FetchFaqParams } from '@module/apis/client-side/customer/type';
import { itemsPerPage } from '@module/constants/pagenation';
import { useFaqListQuery } from '@module/queries/customer/customerQueryHooks';
import useModalStore from '@module/stores/useModalStore';
import TimeConstants from '@module/utils/item';
import BaseButton from '@pc/components/atoms/button/BaseButton';
import BasePagenation from '@pc/components/pagenation/BasePagenation';
import NotFoundDisplay from '@pc/components/result/NotFoundDisplay';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@pc/components/ui/accordion';
import { Input } from '@pc/components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@pc/components/ui/select';
import { keepPreviousData } from '@tanstack/react-query';
import type React from 'react';
import { useEffect, useState } from 'react';
function FaqContainer() {
  const $ = _c(34);
  const {
    pushModal
  } = useModalStore();
  const [category, setCategory] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [searchValueForQuery, setSearchValueForQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const currentPageFirstOffset = (currentPage - 1) * itemsPerPage;
  let t0;
  if ($[0] !== category || $[1] !== currentPageFirstOffset || $[2] !== searchValueForQuery) {
    t0 = {
      offset: currentPageFirstOffset,
      limit: itemsPerPage,
      category,
      searchVal: searchValueForQuery
    };
    $[0] = category;
    $[1] = currentPageFirstOffset;
    $[2] = searchValueForQuery;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  let t1;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      placeholderData: keepPreviousData,
      staleTime: TimeConstants.HALF_SECOND * 10
    };
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const {
    data: faqList
  } = useFaqListQuery(t0, t1);
  let t2;
  if ($[5] !== pushModal || $[6] !== searchValue) {
    t2 = event => {
      event.preventDefault();
      if (searchValue.length === 1) {
        pushModal({
          type: "CONFIRM_MODAL",
          options: {
            description: "\uAC80\uC0C9\uC5B4\uB294 2\uAE00\uC790 \uC774\uC0C1 \uC785\uB825\uD574 \uC8FC\uC138\uC694."
          }
        });
        return;
      }
      setSearchValueForQuery(searchValue);
      setCurrentPage(1);
    };
    $[5] = pushModal;
    $[6] = searchValue;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const updateSearchValueToQuery = t2;
  let t3;
  if ($[8] !== searchValue) {
    t3 = () => {
      if (searchValue) {
        setSearchValue("");
      }
      setCurrentPage(1);
    };
    $[8] = searchValue;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== category) {
    t4 = [category];
    $[10] = category;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  useEffect(t3, t4);
  let t5;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = value => {
      if (!value || value === "all") {
        setCategory("");
        return;
      }
      setCategory(value as FetchFaqParams['category']);
    };
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <SelectTrigger className="h-12 w-40 bg-transparent"><SelectValue placeholder={"\uC804\uCCB4"} /></SelectTrigger>;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Select onValueChange={t5}>{t6}<SelectContent><SelectItem key="all" value="all">{"\uC804\uCCB4"}</SelectItem><SelectItem key="cast" value="cast">{"\uBC29\uC1A1"}</SelectItem><SelectItem key="live" value="live">{"\uC2DC\uCCAD"}</SelectItem><SelectItem key="item" value="item">{"\uD558\uD2B8/\uC544\uC774\uD15C"}</SelectItem><SelectItem key="pay" value="pay">{"\uACB0\uC81C"}</SelectItem><SelectItem key="account" value="account">{"\uD68C\uC6D0 \uACC4\uC815"}</SelectItem><SelectItem key="etc" value="etc">{"\uAE30\uD0C0"}</SelectItem></SelectContent></Select>;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = e => setSearchValue(e.currentTarget.value);
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== searchValue) {
    t9 = <Input className="px-[17px]" placeholder={"\uAC80\uC0C9\uC5B4\uB97C \uC785\uB825\uD574 \uC8FC\uC138\uC694."} value={searchValue} onChange={t8} />;
    $[16] = searchValue;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <BaseButton type="submit" variant="primary" className="ml-2 w-[68px] text-[17px]" size="md">{"\uAC80\uC0C9"}</BaseButton>;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t9 || $[20] !== updateSearchValueToQuery) {
    t11 = <div className="flex justify-between">{t7}<form className="flex" onSubmit={updateSearchValueToQuery}>{t9}{t10}</form></div>;
    $[19] = t9;
    $[20] = updateSearchValueToQuery;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== faqList) {
    t12 = faqList && <Accordion type="single" collapsible={true} className="mt-[35px] mb-8 text-colorFg18">{faqList.list.map(_temp2)}</Accordion>;
    $[22] = faqList;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== faqList?.list.length) {
    t13 = faqList?.list.length === 0 && <NotFoundDisplay text={"\uAC80\uC0C9\uC5B4\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4.\n\uACE0\uAC1D\uC13C\uD130\uB85C \uBB38\uC758\uBC14\uB78D\uB2C8\uB2E4."} />;
    $[24] = faqList?.list.length;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  const t14 = faqList?.page;
  let t15;
  if ($[26] !== currentPage || $[27] !== t14) {
    t15 = <BasePagenation currentPage={currentPage} setCurrentPage={setCurrentPage} pageData={t14} />;
    $[26] = currentPage;
    $[27] = t14;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  let t16;
  if ($[29] !== t11 || $[30] !== t12 || $[31] !== t13 || $[32] !== t15) {
    t16 = <>{t11}{t12}{t13}{t15}</>;
    $[29] = t11;
    $[30] = t12;
    $[31] = t13;
    $[32] = t15;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  return t16;
}
function _temp2(item) {
  return <AccordionItem key={item.idx} value={String(item.idx)}><AccordionTrigger onClick={_temp}>{`Q. ${item.subject}`}</AccordionTrigger><AccordionContent><div className="break-all bg-colorBg01 px-10 pb-5" dangerouslySetInnerHTML={{
        __html: item.contents
      }} /></AccordionContent></AccordionItem>;
}
function _temp() {
  window.scrollTo(0, 0);
}
export default FaqContainer;